var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("pui-form-type-ahead", {
    attrs: {
      "is-loading": _vm.isLoading,
      "is-valid": _vm.isValid,
      options: _vm.searchResults,
      "use-local-cache": false,
      label: _vm.$t("commentLightbox.fields.people.label"),
      multiple: true,
    },
    on: {
      abort: _vm.clearSearchResults,
      change: _vm.userChanged,
      search: _vm.fetchUsers,
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (data) {
          return [
            _c("pui-avatar", {
              attrs: {
                username: data.option.label,
                initials: _vm.avatarInitials(data.option.name),
                size: "24px",
                "small-username": "",
                noedit: "",
                noshadow: "",
              },
            }),
          ]
        },
      },
    ]),
    model: {
      value: _vm.userInput,
      callback: function ($$v) {
        _vm.userInput = $$v
      },
      expression: "userInput",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }